import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-117">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#E8EDE6] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-118"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#E8EDE6] rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-119"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="text-center mb-10" data-id="element-122">
            <div className="inline-flex items-center justify-center p-3 bg-[#FAF7F2] rounded-full mb-6" data-id="element-123">
              <SparklesIcon className="w-8 h-8 text-[#4A6741]" data-id="element-124" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] mb-8" data-id="element-125">
              El Mecanismo Único: El Reseteo Enzimático de 7 Horas
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-126">
          <div className="bg-[#FAF7F2] p-8 md:p-12 rounded-2xl shadow-sm border border-[#E8EDE6] text-center" data-id="element-127">
            <p className="text-xl md:text-2xl text-[#4A6741] font-serif italic mb-6" data-id="element-128">
              En lugar de "quemar", vamos a "desinflamar".
            </p>
            <p className="text-lg md:text-xl text-[#6B6560] leading-relaxed" data-id="element-129">
              Este protocolo utiliza combinaciones de alimentos específicos y
              técnicas de respiración que desactivan la señal de alerta de tu
              cuerpo, permitiendo que el abdomen recupere su forma natural de
              manera casi inmediata.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}